export default {
  os_title: "Operating systems",
  agents: "Agents",
  software: "Software",
  version: "Version",
  version_update: "Versions & updates",
  no_update: "No updates available for {{os}}",
  add_app: "Add Software",
  additional_app: "Additional software",
  application_onboard_title: "Software (Optional)",
  applications: "Software",
  application_number_desc: "and {{count}} more Software",
  no_application: "There are no Software",
  no_application_assigned: "No software has been assigned to this user",
  department_app: "Group Software",
  auto_install: "Auto-install",
  assign_app: "Assign additional software to user",
  apps: "apps",
  apps_for_user: "Apps for this user",
  upload_enterprise: "Upload enterprise app",
  upload_your_app: "Upload your software here",
  add_successfully: "App Added Successfully",
  drag_drop: "Drag & Drop or browse to choose a file",
  only_ipa: "Only .ipa .(maximum 2 GB)",
  only: "Only",
  successfully_uploaded: "Your file successfully uploaded",
  icon: "Icon",
  app_name: "Software name",
  select_category: "Select category",
  version_optional: "Version (Optional)",
  description: "Description",
  ipa_file: "IPA File",
  pkg_file: "PKG file",
  manifest_url: "Manifest URL",
  app_store: "App Store",
  result_for: "Result for",
  assign_application: "Assign software",
  add: "Add",
  add_assign: "Add & Assign",
  search: "Search",
  no_result: "No results",
  app_not_available: "The software you searched for is not available.",
  sure_add_library:
    "Are you sure you want to add this app to your App Library?",
  add_library: "Add {{trackName}} to App Library",
  search_your_app: "Search your app",
  search_app_want: "Search the software you want",
  assign_department: "Assigned Autopilot",
  edit: "Edit",
  discard: "Discard",
  no_department: "No Autopilot",
  publisher: "Publisher",
  category: "Category",
  size: "Size",
  source: "Source",
  price: "Price",
  managed: "Managed",
  compatibility: "Compatibility",
  app_remmove_success: "App Removed Successfully",
  remove_from_library: "Delete from Library",
  configs: "Configs",
  managedConfiguration: "Managed Configuration",
  show_less: "Show less",
  show_more: "Show more",
  install_version: "Installed versions:",
  device: "device",
  not_install: "Not installed",
  sure_remove_library:
    "Are you sure you want to delete this app from your library?",
  remove: "Remove",
  members: "members",
  devices: "Devices",
  auto_instal: "Install Type",
  app_info: "Software information",
  custom: "Custom",
  enterprise: "Enterprise",
  ENTERPRISE: "Enterprise",
  assign_to_deppartment: "Assign to autopilot",
  assign_to_devices: "Assign to devices",
  free: "Free",
  premium: "Premium",
  no_vpp: "No VPP licence",
  all_app: "All apps",
  all_app_des:
    "The Software section lets you manage apps across all operating systems—add apps from official stores or upload APKs, enforce policies, and ensure security and compliance.",
  search_in_app: "Search in software",
  selected: "Selected",
  actions: "Actions",
  add_application: "Add software",
  app_action: "Software actions",
  application_name: "Software Name",
  no_devices: "No Devices",
  filters: "Filters",
  apply: "Apply",
  app_success_assign: "App Successfully Assigned",
  application: "software",
  active_all: "Active all",
  modify_app: "Modify Software",
  select_app_assign: "Select Software to Assign",
  no_software_yet: "No Software Added Yet",
  overview_software:
    "Overview of Software automatically show inclusive Security,",
  operating_sys: "Operating System and ets.",
  add_windows: "Add Windows apps",
  add_ios: "Add iPhone apps",
  add_iPadOS: "Add iPad apps",
  add_mac: "Add Mac apps",
  add_enterprise: "Upload enterprise apps",
  add_to_library: "Add to library",
  search_for_ios: "Search for iPhone apps",
  search_for_iPadOS: "Search for iPad apps",
  search_for_mac: "Search for Mac apps",
  search_for_windows: "Search for Windows apps",
  search_for_enterprise: "Description",
  no_app_added: "No software added yet",
  once_app_added:
    "Once the apps are added, the list will be automatically updated",
  software_overview: "Software Overview",
  software_overview_sub:
    "Keep your software and software up-to-date and manage them all in one place.",
  add_software: "Add new software",
  recently_added: "Recently added",
  show_all: "Show all",
  most_recent_license: "Most recent license usage ",
  total_license: "Total licenses",
  assign_license: "Assigned Licenses",
  vpp_expire: "VPP expiry",
  until_vpp_expire: "until VPP expires",
  most_used: "Most used",
  all_software: "All software",
  department_view: "Autopilot view",
  on: "On",
  off: "Off",
  all_mac: "All Mac Software",
  versionsUpdate: "Versions & updates",
  os_version: "OS version",
  apkFile: "APK file",
  search_for_android: "Add Android apps",
  add_android_enterprise: "Add Android enterprise apps",
  addedYourABM: "This software isn't added to your ABM list.",
  addApplicationConfiguration: "Add software configuration?",
  wouldLikeAddConfiguration: "Would you like to add configuration to this app?",
  TRIO_STORE: "Trio Store",
  APPSTORE: "App Store",
  delete_title: "Delete Archive?",
  delete_description: "Do you want to delete the archive permanently?",
  delete_warning: "This action cannot be undone.",
  delete_cancel: "Cancel",
  delete_delete: "Delete",
};
